// src/views/ConfiguracionGral/ParametrosGrales/VerParametro.jsx
import React from "react";

export default function VerParametro({ data, onClose = () => {} }) {
  if (!data) return null;

  const rows = [
    ["Nombre", data.nombre ?? ""],
    ["Valor", data.valor ?? ""],
    ["Fecha", data.fecha || "—"],
    ["Número", data.numero || "—"],
    ["Prioridad", data.prioridad || "—"],
  ];

  return (
    <div className="modal-backdrop">
      <div className="modal-panel-lg">
        {/* HEADER */}
        <div className="modal-header">
          <h2 className="section-title">📄 Datos del Parámetro</h2>
        </div>

        {/* BODY */}
        <div className="modal-body">
          <div className="form-grid mb-4">
            {rows.map(([label, value]) => (
              <Fila key={label} label={label} value={value} />
            ))}
          </div>
        </div>

        {/* FOOTER */}
        <div className="modal-footer">
          <div className="flex justify-end">
            <button className="btn-fil" onClick={onClose}>
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function Fila({ label, value }) {
  return (
    <div className="form-row">
      <div className="form-label">{label}:</div>
      <div className="value">{value || ""}</div>
    </div>
  );
}
